import React from 'react'

export default function IconButton({children, className, buttonType, ...props}) {
  return (
    <button className={`${buttonType == "default"? "" : "btn-icon"} ${className ?? ""}`} {...props}>{children}</button>
  )
}
